<template>
  <div class="container-fluid pt-0 mt-0">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>

    <AddDrivers
      v-if="showModal"
      :show="showModal"
      :onCancel="closeModal"
      @showSuccessPopup="handleSuccessPopup"
    />

    <DeleteModal
      :show="showDelete"
      @submit="doDelete"
      @close="closeDelete"
      :name="$t('driver')"
    />

    <EditDriver
      v-if="editDriverModal"
      :driver="editedDrivers"
      :show="editDriverModal"
      v-on:closeEditDriverModal="editDriverModal = false"
      @showSuccessPopup="handleSuccessPopup"
    />

    <SuccessModal
      :show="showSuccessPopup"
      @close="showSuccessPopup = false"
      :msg="successMsg"
      :heading="successHeading"
    />

    <div
      style="
        background-color: #fff;
        max-height: 40rem;
        overflow-y: auto;
        width: 100%;
        height: fit-content;
      "
    >
      <div class="card-body" style="overflow-x: auto; width: 100%">
        <div class="header d-flex justify-content-between align-items-center">
          <p>{{ $t("drivers") }}</p>
          <TableSearch @handleSearch="handleSearch" />
        </div>

        <div class="row">
          <div class="col-md-12">
            <div ref="content" class="table-responsive">
              <table id="order-listing" class="table table-hover display">
                <thead style="background-color: rgba(240, 244, 251, 0.6)">
                  <tr>
                    <th
                      :key="index"
                      v-for="(column, index) in tableColumns"
                      @click="sortBy(column[1])"
                      style="cursor: pointer; text-align: left"
                    >
                      {{ column[0] }}
                      <span
                        class="arrow"
                        :class="sortOrders[column[1]] > 0 ? 'asc' : 'dsc'"
                      ></span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(driver, index) in paginatedData"
                    :key="index"
                    class="user-row"
                    style="border-bottom: unset"
                    :class="{
                      'data-table-bg': index % 2 !== 0,
                    }"
                    @click="navigateToDriverDetails(driver.id)"
                  >
                    <td>{{ driver.name }}</td>
                    <td>
                      {{
                        driver.assignedVehicleData
                          ? driver.assignedVehicleData.name
                          : "-"
                      }}
                    </td>

                    <td>{{ driver.email }}</td>

                    <td>{{ driver.phoneNumber }}</td>
                    <td style="display:flex; align-items: center; gap: 8px;">
                      <div :class="circleClass(driver.isActive)"></div>
                      <span>{{ statusText(driver.isActive) }}</span>
                    </td>

                    <td>
                      <div class="d-flex align-items-center col-gap-1">
                        <span
                          class="cursor-pointer"
                          @click.stop="editdriver(driver)"
                        >
                          <IconEdit />
                        </span>
                        <span
                          class="cursor-pointer"
                          @click.stop="openDelete(driver.id)"
                        >
                          <IconDelete />
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Pagination
              :pageCount="pageCount"
              :data="paginatedData"
              :sizeperpage="sizeperpage"
              :pageNumber="pageNumber"
              :pages="pages"
              @goToLastPage="goToLastPage"
              @nextPage="nextPage"
              @handlePageChange="handlePageChange"
              @goToFirstPage="goToFirstPage"
              @prevPage="prevPage"
              @onchange="onchange"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import "intro.js/introjs.css";

import AddDrivers from "../../views/Modals/AddDrivers.vue";
import TableSearch from "../../components/TableSearch.vue";
import IconEdit from "../../components/Iconsvg/IconEditUser.vue";
import IconDelete from "../../components/Iconsvg/IconDeleteUser.vue";
import DeleteModal from "../Modals/DeleteModal.vue";
import Pagination from "../../components/PaginationNew.vue";
import tableMixin from "../../mixins/tableMixinWithBackend";
import EditDriver from "../Modals/EditDriver";
import SuccessModal from "../Modals/SuccessModal.vue";

export default {
  name: "DispatchDrivers",
  mixins: [tableMixin],
  components: {
    Loading,
    AddDrivers,
    Pagination,
    TableSearch,
    IconEdit,
    IconDelete,
    DeleteModal,
    EditDriver,
    SuccessModal,
  },
  mounted() {
    this.fetchDrivers(this.params);
  },
  props: {
    showModal: Boolean,
    closeModal: Function,
  },
  data() {
    return {
      isLoading: true,

      fullPage: true,

      showDelete: false,
      sortOrders: {},
      editDriverModal: false,

      editedDrivers: [],

      dataTable: [],

      showSuccessPopup: false,

      successMsg: "",
      successHeading: "",
    };
  },
  computed: {
    ...mapGetters(["drivers", "meta"]),
    paginationMeta() {
      return this.meta;
    },
    tableColumns() {
      return [
        [this.$t("name"), "fullname"],
        [this.$t("vehicles"), "vehicles"],
        [this.$t("emailModal.emailAddress"), "email"],
        [this.$t("phone_num"), "phonenumber"],
        [this.$t("status"), "status"],
        [this.$t("action"), "column2"],
      ];
    },
  },
  methods: {
    ...mapActions(["getDrivers", "addDrivers", "editDriver", "deleteDriver"]),

    handleSuccessPopup({ msg, heading }) {
      this.successMsg = msg;
      this.successHeading = heading;
      this.showSuccessPopup = true;
    },
    statusText(isActive) {
      return isActive ? this.$t("available") : this.$t("unavailable");
    },
    circleClass(isActive) {
      return {
        circle: true,
        available: isActive,
        unavailable: !isActive,
      };
    },
    closeDelete() {
      this.showDelete = false;
    },
    doDelete() {
      this.isLoading = true;
      this.deleteDriver(this.id).then(() => {
        this.getDrivers();
        this.isLoading = false;
        this.showDelete = false;

        this.showSuccessPopup = true;

        this.successMsg = this.$t("deleted_driver_mssg");
        this.successHeading = this.$t("deleted_driver_heading");
      });
    },
    openDelete(id) {
      this.showDelete = true;
      this.id = id;
    },
    editdriver(DriverInfo) {
      this.editedDrivers = [DriverInfo];
      this.Tag = "";

      this.editDriverModal = true;
    },

    doSearch() {
      let params = {
        ...this.params,
        name: this.searchQuery,
      };
      this.fetchDrivers(params);
    },
    fetchDrivers(params) {
      this.isLoading = true;
      this.getDrivers(params)
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    navigateToDriverDetails(driverId) {
      this.$router.push({ name: "DriverDetails", params: { id: driverId } });
    },
  },
  watch: {
    drivers: {
      handler: function() {
        this.dataTable = this.drivers;
        console.log(this.drivers)
      },
      deep: true,
    },
    params() {
      this.fetchDrivers(this.params);
    },
  },
};
</script>

<style scoped>
.header {
  margin-bottom: 1rem;
}

.header > p {
  font-size: 14px;
  font-weight: 700;
  line-height: 18.2px;
  color: rgba(64, 74, 87, 1);
  margin-top: 1rem;
}

.circle {
  height: 10px;
  width: 10px;
  border-radius: 100%;
}

.circle.available {
  background-color: rgba(40, 168, 74, 1);
}

.circle.unavailable {
  background-color: rgba(235, 87, 87, 1);
}
</style>
